import { render, staticRenderFns } from "./RefundCreateCreditInformModal.vue?vue&type=template&id=31200e55&"
import script from "./RefundCreateCreditInformModal.vue?vue&type=script&lang=ts&"
export * from "./RefundCreateCreditInformModal.vue?vue&type=script&lang=ts&"
import style0 from "./RefundCreateCreditInformModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CAccordionItem: require('@chakra-ui/vue').CAccordionItem, CAccordion: require('@chakra-ui/vue').CAccordion})
